export const BMS = [
  'ADVANCE7',
  'ALPHACRM',
  'AUTOFLOW',
  'AUTOGLASS',
  'AUTOSOFT',
  'AUTOVIEW',
  'AVANT',
  'BMS',
  'BODYNET',
  'BSD',
  'EMACS',
  'FIXCLOUD',
  'HAL',
  'iIMAGE',
  'JARVIS',
  'MANUAL',
  'PINNACLE',
  'PLANMANAGER',
  'UNITY',
  'UNKNOWN',
  'VOYAGER',
];